var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4835_3434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 73,
    width: 149,
    height: 84
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5938 73.792C33.2138 73.792 32.0938 74.912 32.0938 76.292V153.792C32.0938 155.173 33.2138 156.292 34.5938 156.292H178.344C179.725 156.292 180.844 155.173 180.844 153.792V76.292C180.844 74.912 179.725 73.792 178.344 73.792H34.5938Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4835_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8438 157.542H182.094V72.542H30.8438V157.542Z",
    fill: "#E1E3E6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4835_3434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 89,
    width: 150,
    height: 79
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2487 89.1865C48.8687 89.1865 47.75 90.3065 47.75 91.6865V164.975C47.75 166.357 48.8687 167.477 50.2487 167.477H194C195.38 167.477 196.499 166.357 196.499 164.975V91.6865C196.499 90.3065 195.38 89.1865 194 89.1865H50.2487Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4835_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5 168.727H197.75V87.9365H46.5V168.727Z",
    fill: "#E1E3E6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3945 66.8848H183.737C185.117 66.8848 186.237 68.0035 186.237 69.3848V153.859C186.237 155.24 185.117 156.359 183.737 156.359H34.3945C33.0133 156.359 31.8945 155.24 31.8945 153.859V69.3848C31.8945 68.0035 33.0133 66.8848 34.3945 66.8848Z",
    stroke: "#1E4246",
    strokeWidth: 3.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4835_3434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 128,
    width: 19,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5547 128.33H60.4497V157.409H42.5547V128.33Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4835_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3047 158.659H61.6997V127.08H41.3047V158.659Z",
    fill: "#5E3BBF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4835_3434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 108,
    width: 19,
    height: 50
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6289 108.2H89.5239V157.41H71.6289V108.2Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4835_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3789 158.657H90.7739V106.947H70.3789V158.657Z",
    fill: "#5E3BBF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4835_3434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 132,
    width: 19,
    height: 26
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.715 132.806H118.61V157.411H100.715V132.806Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4835_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4648 158.661H119.86V131.556H99.4648V158.661Z",
    fill: "#5E3BBF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4835_3434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 108,
    width: 19,
    height: 50
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.789 108.2H147.683V157.41H129.789V108.2Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4835_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.539 158.657H148.934V106.947H128.539V158.657Z",
    fill: "#5E3BBF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4835_3434",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 84,
    width: 19,
    height: 74
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.75 84.7129H175.644V157.41H157.75V84.7129Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4835_3434)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.5 158.66H176.895V83.4629H156.5V158.66Z",
    fill: "#5E3BBF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3945 152.689L79.5445 108.251L108.681 133.747L196.5 59.3848",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5898 66.8184H183.932C185.312 66.8184 186.432 67.9371 186.432 69.3184V153.792C186.432 155.173 185.312 156.292 183.932 156.292H34.5898C33.2086 156.292 32.0898 155.173 32.0898 153.792V69.3184C32.0898 67.9371 33.2086 66.8184 34.5898 66.8184Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.656 162.41V221.16H258.406",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeDasharray: "3.75 7.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.351 244.24C247.572 243.183 248.257 241.485 250.377 241.485C251.738 241.485 253.15 241.495 254.566 241.497C254.607 241.495 254.64 241.485 254.681 241.485C255.265 241.485 255.86 241.487 256.457 241.489C261.946 241.444 267.2 241.119 269.566 239.315C271.352 237.954 271.141 235.503 271.141 235.503H251.902H247.597H247.296H242.991H223.336V244.043C223.336 244.608 223.793 245.065 224.358 245.065H246.348C246.837 245.065 247.251 244.719 247.351 244.24Z",
    fill: "#CECECE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.301 175.949C241.462 175.949 238.729 176.397 236.162 177.213C228.038 181.828 222.547 190.543 222.547 200.554V234.417C222.547 235.015 223.033 235.502 223.632 235.502H271.146V202.794C271.146 187.968 259.127 175.949 244.301 175.949Z",
    fill: "#CECECE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.153 235.503H223.632C223.033 235.503 222.547 235.017 222.547 234.418V200.556C222.547 185.73 234.567 173.711 249.393 173.711V173.711C264.219 173.711 276.238 185.73 276.238 200.556V234.418C276.238 235.017 275.752 235.503 275.153 235.503Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.445 235.503H251.901H247.296H223.336V244.044C223.336 244.608 223.793 245.065 224.358 245.065H250.652C251.141 245.065 251.555 244.719 251.655 244.24C251.876 243.184 252.561 241.485 254.681 241.485C261.946 241.485 270.625 241.79 273.871 239.315C275.657 237.954 275.445 235.503 275.445 235.503Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.239 222.513V222.513V215.952C276.528 215.952 276.761 216.186 276.761 216.473V221.991C276.761 222.28 276.528 222.513 276.239 222.513Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.55 222.513V222.513C222.262 222.513 222.028 222.279 222.028 221.992V214.81C222.028 214.523 222.262 214.289 222.55 214.289V222.513Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 191.763C250 192.096 249.728 192.368 249.395 192.368C249.061 192.368 248.79 192.096 248.79 191.763C248.79 191.429 249.061 191.158 249.395 191.158C249.728 191.158 250 191.429 250 191.763Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.102 247.559H229.138C228.696 247.559 228.311 247.26 228.202 246.833L227.75 245.066H236.49L236.038 246.833C235.929 247.26 235.544 247.559 235.102 247.559Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.532 247.559H239.567C239.126 247.559 238.741 247.26 238.632 246.833L238.18 245.066H246.92L246.467 246.833C246.358 247.26 245.973 247.559 245.532 247.559Z",
    stroke: "#3D3D3D",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingAnalysis);
export default __webpack_public_path__ + "static/media/loading_analysis.b372953c1837a37e0402b5db177fe0ce.svg";
export { ForwardRef as ReactComponent };